import React from 'react'
import { Spinner } from 'react-bootstrap'

const AppSpinner = () => {
  return (
    <Spinner animation="border" variant="primary" />
  )
}

export default AppSpinner